export const studentReferralsInfo = [
  {
    title: "Male Students",
    percentage: 64,
    color: "#6C5DD3",
  },
  {
    title: "Female Students",
    percentage: 40,
    color: "#7FBA7A",
  },
  {
    title: "Day Students",
    percentage: 50,
    color: "#FFCE73",
  },
  {
    title: "Boarding Students",
    percentage: 80,
    color: "#FFA2C0",
  },
];
